export default __webpack_public_path__ + "static/media/A.f2bec363.png";